import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as qs from "qs";
import axiosApi from "../../../utils/httpClient";
const name = "exploreMentors";
const initialState = {
  exploreMentors: [],
  loading: false,
  error: null,
};

export const exploreMentorsAPI = createAsyncThunk(
  "exploreMentors",
  async ({ skip, limit, country, industries, stage, skills, search }) => {
    var formData = {};
    // formData["id"] = id;
    formData["skip"] = skip;
    // formData["model"] = model;
    // formData["status"] = status;
    formData["limit"] = limit;
    if (country) {
      formData["country"] = country;
    }
    if (industries) {
      formData["industries"] = industries;
    }
    if (stage) {
      formData["stage"] = stage;
    }
    if (skills) {
      formData["skills"] = skills;
    }
    if (search) {
      formData["search"] = search;
    }

    const data = await axiosApi.get(
      `${process.env.REACT_APP_BASE_URL}mentor/`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

const exploreMentorsSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(exploreMentorsAPI.pending, (state) => {
      state.exploreMentors = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(exploreMentorsAPI.fulfilled, (state, action) => {
      state.exploreMentors = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(exploreMentorsAPI.rejected, (state, action) => {
      state.exploreMentors = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default exploreMentorsSlice.reducer;
